import { render, staticRenderFns } from "./ProjectUsers.vue?vue&type=template&id=53cabbad&scoped=true&lang=pug"
import script from "./ProjectUsers.vue?vue&type=script&lang=js"
export * from "./ProjectUsers.vue?vue&type=script&lang=js"
import style0 from "./ProjectUsers.vue?vue&type=style&index=0&id=53cabbad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cabbad",
  null
  
)

export default component.exports